(() => {
  if (customElements.get('related-products-slider')) return;

  class RelatedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.splideReadyAttempts = 0;
      this.onResize = () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.configure(), 150);
      };

      window.addEventListener('resize', this.onResize);
      this.configure();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.splideReadyTimer);
      this.destroySlider();
    }

    configure() {
      if (!this.isConnected) return;

      if (!window.Splide) {
        if (this.splideReadyAttempts < 20) {
          this.splideReadyAttempts += 1;
          window.clearTimeout(this.splideReadyTimer);
          this.splideReadyTimer = window.setTimeout(() => this.configure(), 100);
        }
        return;
      }

      this.splideReadyAttempts = 0;
      window.clearTimeout(this.splideReadyTimer);

      const root = this.querySelector('.related-products__slider');
      if (!root) return;

      const count = root.querySelectorAll('.related-products__slide').length;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const isTablet = window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches;
      const desktopColumns = Math.max(1, Number(this.dataset.desktop) || 4);
      const mobileColumns = Math.max(1, Number(this.dataset.mobile) || 1);
      const columns = isMobile ? mobileColumns : isTablet ? Math.min(desktopColumns, 2) : desktopColumns;

      if (count <= columns) {
        this.destroySlider();
        return;
      }

      if (this.splide && this.activeColumns === columns) return;
      this.destroySlider();

      this.splide = new window.Splide(root, {
        type: 'loop',
        perPage: columns,
        perMove: 1,
        gap: `${Number.parseInt(getComputedStyle(this).getPropertyValue('--related-products-gap'), 10) || 24}px`,
        arrows: true,
        pagination: false,
        autoplay: false,
        rewind: this.dataset.rewind === 'true',
        speed: Number(this.dataset.speed) || 500,
        drag: true,
        keyboard: 'focused',
        breakpoints: {
          989: { perPage: 2, gap: '20px' },
          749: { perPage: mobileColumns, gap: '16px' }
        }
      });

      this.splide.mount();
      this.activeColumns = columns;
      root.classList.add('is-initialized');
    }

    destroySlider() {
      const root = this.querySelector('.related-products__slider');
      if (this.splide) this.splide.destroy(true);
      this.splide = null;
      this.activeColumns = null;
      if (root) root.classList.remove('is-initialized');
    }
  }

  customElements.define('related-products-slider', RelatedProductsSlider);
})();
